// https://debankglobal.larksuite.com/docx/C4F7deBEkoGWnmxWAxuurcPbshf
import { useQuery } from 'react-query';

import { request, useCurrentUserId } from '@/utils';

import { NFT, NFTCollection } from '@/components/AvatarEditable/types';
import { PortfolioProject, PortfolioItem } from '@/views/Portfolio/types';

export const useChainNonce = (chain: string) => {
  const url = '/chain/nonce';
  const currentId = useCurrentUserId();

  return useQuery([url, currentId, chain], ({ signal }) =>
    request.get<number>(
      url,
      {
        chain,
        user_addr: currentId,
      },
      { signal },
    ),
  );
};

export const useActionEligible = (id: number) => {
  const url = '/quest/action/is_eligible';
  const currentId = useCurrentUserId();

  return useQuery([url, currentId, id], ({ signal }) =>
    request.post<{ is_eligible: boolean }>(url, { id }, { signal }),
  );
};

export const useContractInteracted = (id: string, chain: string) => {
  const url = '/contract/check_interacted';
  const currentId = useCurrentUserId();

  return useQuery([url, currentId, id, chain], ({ signal }) =>
    request.get<{ is_interacted: boolean }>(
      url,
      {
        id,
        chain_id: chain,
        user_id: currentId,
      },
      { signal },
    ),
  );
};

export const useUserTokenList = (ids: string, chain: string) => {
  const url = '/token/list';
  const currentId = useCurrentUserId();

  return useQuery([url, currentId, ids, chain], ({ signal }) =>
    request.get<TokenWithAmount[]>(
      url,
      {
        ids,
        chain_id: chain,
        user_addr: currentId,
      },
      { signal },
    ),
  );
};

export const useUserPortfolioList = (id: string) => {
  const url = '/portfolio/list';
  const currentId = useCurrentUserId();

  return useQuery([url, currentId, id], ({ signal }) =>
    request.get<{ portfolio_list: PortfolioItem[]; project: PortfolioProject }>(
      url,
      {
        user_addr: currentId,
        project_id: id,
      },
      { signal },
    ),
  );
};

export const useUserNftList = (collection_ids: string, chain: string) => {
  const url = '/nft/list';
  const currentId = useCurrentUserId();

  return useQuery([url, currentId, collection_ids, chain], ({ signal }) =>
    request.get<{
      collection_dict: Record<string, NFTCollection>;
      token_list: NFT[];
    }>(
      url,
      {
        collection_ids,
        chain_id: chain,
        user_addr: currentId,
      },
      { signal },
    ),
  );
};
